module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-booking-mode"
  }, [(_vm.$is('select')) ? _c('select', {
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "change": function($event) {
        return _vm.$emit('input', $event.target.value)
      }
    }
  }, [(_vm.isFilter) ? _c('option', {
    attrs: {
      "selected": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("All booking types")]) : _vm._e(), _vm._l((_vm.bookingModes), function(bookingMode, key) {
    return _c('option', {
      domProps: {
        "selected": _vm.value === key,
        "value": key
      }
    }, [_vm._v(_vm._s(bookingMode))])
  })], 2) : (_vm.$is('checkbox')) ? _c('fieldset', [_c('h3', [_vm._v("Booking Modes")]), _vm._l((_vm.bookingModes), function(bookingMode, key) {
    return [_c('label', [_vm._v(_vm._s(bookingMode)), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selected),
        expression: "selected"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": key,
        "checked": _vm.value === key,
        "checked": Array.isArray(_vm.selected) ? _vm._i(_vm.selected, key) > -1 : (_vm.selected)
      },
      on: {
        "change": [function($event) {
          var $$a = _vm.selected,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = key,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selected = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.selected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selected = $$c
          }
        }, function($event) {
          return _vm.$emit('input', _vm.selected)
        }]
      }
    })])]
  })], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e6538eb2!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/BookingModeSelect.vue
// module id = 2569
// module chunks = 1